/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_SqftInputs */

const en_admin_resource_form_sqft = /** @type {(inputs: Admin_Resource_Form_SqftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sqft`)
};

const de_admin_resource_form_sqft = /** @type {(inputs: Admin_Resource_Form_SqftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sqft`)
};

const es_admin_resource_form_sqft = /** @type {(inputs: Admin_Resource_Form_SqftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sqft`)
};

const fr_admin_resource_form_sqft = /** @type {(inputs: Admin_Resource_Form_SqftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sqft`)
};

const nl_admin_resource_form_sqft = /** @type {(inputs: Admin_Resource_Form_SqftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sqft`)
};

/** @type {(inputs: Admin_Resource_Form_SqftInputs) => LocalizedString} */
const it_admin_resource_form_sqft = en_admin_resource_form_sqft;

/** @type {(inputs: Admin_Resource_Form_SqftInputs) => LocalizedString} */
const pt_br2_admin_resource_form_sqft = en_admin_resource_form_sqft;

/** @type {(inputs: Admin_Resource_Form_SqftInputs) => LocalizedString} */
const pl_admin_resource_form_sqft = en_admin_resource_form_sqft;

/** @type {(inputs: Admin_Resource_Form_SqftInputs) => LocalizedString} */
const hu_admin_resource_form_sqft = en_admin_resource_form_sqft;

/** @type {(inputs: Admin_Resource_Form_SqftInputs) => LocalizedString} */
const ro_admin_resource_form_sqft = en_admin_resource_form_sqft;

/**
* | output |
* | --- |
* | "sqft" |
*
* @param {Admin_Resource_Form_SqftInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_sqft = /** @type {((inputs?: Admin_Resource_Form_SqftInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_SqftInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_sqft(inputs)
	if (locale === "de") return de_admin_resource_form_sqft(inputs)
	if (locale === "es") return es_admin_resource_form_sqft(inputs)
	if (locale === "fr") return fr_admin_resource_form_sqft(inputs)
	if (locale === "nl") return nl_admin_resource_form_sqft(inputs)
	if (locale === "it") return it_admin_resource_form_sqft(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_sqft(inputs)
	if (locale === "pl") return pl_admin_resource_form_sqft(inputs)
	if (locale === "hu") return hu_admin_resource_form_sqft(inputs)
	return ro_admin_resource_form_sqft(inputs)
});
export { admin_resource_form_sqft as "admin.resource_form.sqft" }